import "lightgallery.js";
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import { app } from '../../utils/store';

gsap.registerPlugin(ScrollTrigger);

export default class Gallery{
    constructor(){
        this.header = document.querySelector('header');

        this.article = {
            content: document.querySelector('.article-content'),
        }

        this.gallery = {
            // container: document.getElementById('gallery'),
            image: document.querySelectorAll('.article-content img'),
        };

        this.lightbox = {
            // container: document.getElementById('lightbox'),
            // toggler: document.querySelectorAll('#lightbox li'),
        };
    }

    init() {
        this.toggle();
    }

    toggle = () => {

        // Create a ul
        var lightbox = document.createElement('ul');
        // Assign ID a div
        lightbox.id = "gallery";
        lightbox.className = "d-none";
        
        // Add clone of images inside the '#gallery' div
        this.gallery.image.forEach((image) => {
            var imageSrc = image.getAttribute('src');
            var item = document.createElement('li');

            item.setAttribute('data-src',imageSrc);

            lightbox.appendChild(item);
        });
        
        // Append of '#gallery' to 'article-content'
        this.article.content.appendChild(lightbox);

        // Redefine '#gallery'
        var gallery = document.getElementById('gallery');
        // Create the lightbox
        lightGallery(gallery, {
            mode: 'lg-fade',
            startClass: 'lg-start-fade',
            keypress: true,
            controls: true,
            download: false,
            counter: false,
            enableDrag: false,
            enableTouch: false,
            enableSwipe: true,
            useLeft: true,
            hideControlOnEnd: true,
        });

        // Simulate the click() on '#gallery'
        this.gallery.image.forEach((toggler) => {
            toggler.addEventListener('click', (e) => {
                var target = e.target.getAttribute('src');
                console.log(gallery.querySelector('[src*="'+ target +'"]'))
                gallery.querySelector('[data-src="'+ target +'"]').click();
            });
        });
    }

    animation = () => {
        // Animate using GSAP
    }
}
